import React from 'react';

function Sidebar() {

    return <div class="sidebarWrapper">
              <div class="sidebarHistory">
                
            </div>
          </div>
  }

  export default Sidebar;